import React from 'react'
import Websocket from 'react-websocket'
import {WS_URL} from '../../api'
import {Badge, ListGroupItem} from 'reactstrap'
import HistoryIcon from 'react-icons/lib/fa/history'

let ControllerProvisioningListItem = ({controller, username, reprovisioned, token, downloadLoginLink, handleWebSocketResponse, isMobileDevice = false}) => {
    return <ListGroupItem className="text-left">
        {(controller.online ?
            <Badge color="success" pill>Online</Badge> :
            (reprovisioned ?
                <Badge color="warning" pill>Reprovisioned</Badge> :
                <Badge color="danger" pill>Offline</Badge>))}
        &emsp;

        <strong>Serial&nbsp;Number:&ensp;</strong>
        <span className="ellipsize d-inline-block position-relative" style={{width:'6rem', top: '7px'}}>{controller.serialNumber}</span>
        &ensp;&mdash;&ensp;

        <strong>ICCID&ensp;</strong>
        <span className="ellipsize-left d-inline-block position-relative" style={{width:'6rem', top: '7px'}}>{controller.iccid}</span>
        &ensp;&mdash;&ensp;
        
        <strong>Phone&ensp;Number&ensp;</strong>
        <span className="ellipsize-left d-inline-block position-relative" style={{width:'6rem', top: '7px'}}>{controller.phone}</span>
        &ensp;&mdash;&ensp; 
        

        <strong>User:&ensp;</strong>
        <span className="ellipsize d-inline-block position-relative" style={{width:'11rem', top: '7px'}}>{username}</span>
        &emsp;&emsp;

        {(controller.legacyAccess ?
            <Badge color="warning" className="m-1"><HistoryIcon/>&nbsp;Legacy&nbsp;Software</Badge>
            : null)}

        {(controller.clockErrorActive || controller.clockErrors ?
            (controller.clockErrors && controller.clockErrors > 0 ?
                <Badge color="warning" className="m-1"><HistoryIcon/>&nbsp;{controller.clockErrors}&nbsp;Clock&nbsp;Errors</Badge> :
                <Badge color="warning" className="m-1"><HistoryIcon/>&nbsp;Clock&nbsp;Error</Badge>)
            : null)}
        &emsp;&emsp;

        <a download={`login-${controller.serialNumber}.txt`}
           className="d-block d-sm-inline-block float-none float-sm-right position-relative"
           style={{top:'0.4rem'}}
           href={downloadLoginLink}>
            {isMobileDevice ?
                "Hold Here to Download Login File" :
                "Download Login File"}
        </a>

        {(token ?
            <Websocket url={`${WS_URL}/controllers/${controller.id}/?access_token=${token.accessToken}`}
                       onMessage={handleWebSocketResponse}/> :
            null)}
    </ListGroupItem>
}

export default ControllerProvisioningListItem



// WEBPACK FOOTER //
// ./src/components/ui/ControllerProvisioningListItem.js